import $ from 'jquery';

/**
 * Produkt-Tabs: jQuery slideDown / slideUp (wie ACF-Accordion), inkl. stop gegen „Stocken“.
 *
 * @return {void}
 */
function initRushWcProductTabsAccordion() {
	const $root = $('.rush-wc-product-tabs--accordion');
	if (!$root.length) {
		return;
	}

	const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	const duration = reducedMotion ? 0 : 400;

	$root
		.off('click.rushWcProductTabs', '.rush-wc-product-tab__summary')
		.on('click.rushWcProductTabs', '.rush-wc-product-tab__summary', function (event) {
			event.preventDefault();
			const $btn = $(this);
			const $tab = $btn.closest('.rush-wc-product-tab');
			const $panel = $tab.children('.rush-wc-product-tab__panel');
			if (!$panel.length) {
				return;
			}

			const isOpen = $tab.hasClass('is-open');

			if (isOpen) {
				$tab.removeClass('is-open');
				$btn.attr('aria-expanded', 'false');
				if (reducedMotion) {
					$panel.hide();
					return;
				}
				$panel.stop(true, true).slideUp(duration);
				return;
			}

			$tab.addClass('is-open');
			$btn.attr('aria-expanded', 'true');
			if (reducedMotion) {
				$panel.show();
				return;
			}
			$panel.stop(true, true).slideDown(duration);
		});
}

function initRushWcShopCatMore() {
	const desktop = window.matchMedia('(min-width: 768px)');

	$('.rush-wc-shop-cats__list').each(function () {
		const list = this;
		const $list = $(list);
		const $more = $list.closest('.rush-wc-shop-cats').find('.rush-wc-shop-cats__more');
		if (!$more.length) {
			return;
		}

		const labelMore = $more.data('label-more') || 'alle filter anzeigen';
		const labelLess = $more.data('label-less') || 'weniger filter anzeigen';
		const $first = $list.find('.rush-wc-shop-cats__item').first();
		const $active = $list.find('.is-active').first();
		let expanded = $first.length && $active.length && $active[0].offsetTop > $first[0].offsetTop + 1;

		const sync = function () {
			$list.css('max-height', '').removeClass('is-collapsed');
			$list.find('.rush-wc-shop-cats__item').each(function () {
				this.toggleAttribute('inert', false);
			});

			if (!desktop.matches || !$first.length) {
				$more.prop('hidden', true);
				return;
			}

			const firstTop = $first[0].offsetTop;
			const overflows = $list.find('.rush-wc-shop-cats__item').toArray().some(function (item) {
				return item.offsetTop > firstTop + 1;
			});

			if (!overflows) {
				$more.prop('hidden', true);
				return;
			}

			$more.prop('hidden', false);
			if (expanded) {
				$more.attr('aria-expanded', 'true').text(labelLess);
				return;
			}

			$list.addClass('is-collapsed').css('max-height', $first.outerHeight() + 'px');
			$more.attr('aria-expanded', 'false').text(labelMore);
			$list.find('.rush-wc-shop-cats__item').each(function () {
				this.toggleAttribute('inert', this.offsetTop > firstTop + 1);
			});
		};

		$more.on('click', function () {
			expanded = $more.attr('aria-expanded') !== 'true';
			sync();
		});

		sync();
		$(window).on('resize', sync);
	});
}

$(document).ready(function () {
	initRushWcProductTabsAccordion();
	initRushWcShopCatMore();

	$(document).on('change', '.rush-wc-shop-cats__select', function () {
		const url = $(this).val();
		if (url) {
			window.location.assign(url);
		}
	});

	const $singleCart = $('.single-product form.cart');
	if (!$singleCart.length) {
		return;
	}

	$singleCart.each(function () {
		const $form = $(this);
		const $button = $form.find('.single_add_to_cart_button');
		const $qtyWrap = $form.find('.quantity');
		const $qtyInput = $qtyWrap.find('input.qty');

		if ($button.length) {
			$button.addClass('button--dark button--arrow');
		}

		if (!$qtyWrap.length || !$qtyInput.length || $qtyWrap.hasClass('rush-wc-qty-ready')) {
			return;
		}

		$qtyWrap.addClass('rush-wc-qty-ready');
		$qtyWrap.prepend('<span class="rush-wc-qty-label">Anzahl</span>');
		$qtyInput.before('<button type="button" class="rush-wc-qty-btn rush-wc-qty-btn--minus" aria-label="Anzahl reduzieren">-</button>');
		$qtyInput.after('<button type="button" class="rush-wc-qty-btn rush-wc-qty-btn--plus" aria-label="Anzahl erhöhen">+</button>');

		const adjustQty = function (delta) {
			const input = $qtyInput.get(0);
			if (!input) {
				return;
			}
			const min = input.min !== '' ? parseFloat(input.min) : 1;
			const max = input.max !== '' ? parseFloat(input.max) : Number.POSITIVE_INFINITY;
			const step = input.step && input.step !== 'any' ? parseFloat(input.step) : 1;
			const current = $qtyInput.val() !== '' ? parseFloat($qtyInput.val()) : min;

			if (Number.isNaN(current) || Number.isNaN(step) || Number.isNaN(min)) {
				return;
			}

			const decimals = step.toString().includes('.') ? step.toString().split('.')[1].length : 0;
			let next = current + delta * step;
			next = Math.max(min, next);
			next = Math.min(max, next);

			const value = decimals > 0 ? next.toFixed(decimals) : Math.round(next).toString();
			$qtyInput.val(value).trigger('change');
		};

		$qtyWrap.on('click', '.rush-wc-qty-btn--minus', function () {
			adjustQty(-1);
		});
		$qtyWrap.on('click', '.rush-wc-qty-btn--plus', function () {
			adjustQty(1);
		});
	});
});
